import React, { FC } from 'react';
import { getProductionBatchByProductionOperationId, operationsSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem } from '@interfaces/search';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useJobDetails } from '@v2/pages/common/hooks/useJobDetails';
import { getNCFilesByProductionOperationId } from '@reducers/manufacture';
import NCFileListOrSingleItem from '@v2/pages/machines/modules/now/components/NC-file/components/NCFileListOrSingleItem';
import JobContentWrapper from '@v2/pages/job/common/components/JobContentWrapper';

interface JobDetailsNCFileProps {
  ncFiles: ReducerEntityWithLoadingState<NCFileSearchItem[]>;
  ncFileId: number | null;
}

const JobDetailsNCFileComponent: FC<JobDetailsNCFileProps> = ({
  updateHeaderConfig,
  operationsSearch,
  ncFiles,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
  ncFileId,
}) => {
  const title = useTitle();

  const { ncFileDataLoading } = useJobDetails({
    updateHeaderConfig,
    operationsSearch,
    getNCFilesByProductionOperationId,
    getProductionBatchByProductionOperationId,
    getAllNcFiles: true,
  });

  return (
    <JobContentWrapper loading={false} title={title.ncFile}>
      <NCFileListOrSingleItem
        ncFileData={ncFiles.data}
        ncFileDataLoading={!ncFiles.wasLoaded}
        ncFileId={ncFileId}
        ncFileDataLoadingForList={ncFileDataLoading}
      />
    </JobContentWrapper>
  );
};

const JobDetailsNCFile = connect(({ details: { ncFiles, ncFileId } }) => ({ ncFiles, ncFileId }), {
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
})(JobDetailsNCFileComponent);

export { JobDetailsNCFile };
